export default __webpack_public_path__ + "static/media/HVACR-cdu-3-1024x768.cf3962a9.jpg";